import { render } from "./LabelSwitch.vue?vue&type=template&id=3f9dd467&scoped=true"
import script from "./LabelSwitch.vue?vue&type=script&lang=js"
export * from "./LabelSwitch.vue?vue&type=script&lang=js"

import "./LabelSwitch.vue?vue&type=style&index=0&id=3f9dd467&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9dd467"]])

export default __exports__